import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormGroup, FormBuilder, Validators, FormsModule,ReactiveFormsModule } from '@angular/forms';
import { QueryBuilderViewComponent } from '../query-builder-view/query-builder-view.component';
import { QueryBuilderDynamicFormsComponent } from '../query-builder-view/query-builder-dynamic-forms/query-builder-dynamic-forms.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [QueryBuilderViewComponent,QueryBuilderDynamicFormsComponent],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    AngularMultiSelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule
  ],
  
  exports: [
    QueryBuilderViewComponent,
    QueryBuilderDynamicFormsComponent
  ],
  bootstrap: [QueryBuilderViewComponent],
  entryComponents: [
    //ReportViewComponent,
  ]
})
export class QueryBuilderViewModuleModule { }
